/* eslint-disable import/prefer-default-export */
export const TASK_STATUS_ZHIMA_GO = {
  INIT: 'INIT', // 未开始
  RUNNING: 'RUNNING', // 进行中
  FINISHED: 'FINISHED', // 已结束
  UNFINISHED: 'UNFINISHED', // 过期未完成
  FORCE_STOP: 'FORCE_STOP', // FORCE_STOP
};
